import { CurrentCoverageType } from "types";
import { convertBoolIntoString, ConvertToValidDate } from "utils/helper";
import { CurrentCoverageFormType } from "./formTypes";

export const CurrentCoverageFormValues = (
  formData: CurrentCoverageType
): CurrentCoverageFormType => {
  const healthInsuranceInformation = formData?.healthInsuranceInformation;
  return {
    sicCode: formData?.sicCode || "",
    currentlyOfferHealthInsurance: convertBoolIntoString(
      healthInsuranceInformation?.currentlyOfferHealthInsurance
    ),
    currentCarrier: healthInsuranceInformation?.currentCarrier || "",
    currentCarrierOther: healthInsuranceInformation?.currentCarrierOther || "",
    currentRenewalDate:
      ConvertToValidDate(healthInsuranceInformation?.currentRenewalDate) || "",
    cobraUsage: convertBoolIntoString(healthInsuranceInformation?.cobraUsage),
    cobraUsers: healthInsuranceInformation?.cobraUsers?.toString() || "",
    benefitEligibleEmployees:
      healthInsuranceInformation?.benefitEligibleEmployees?.toString() || "",
    controlledGroup:
      convertBoolIntoString(healthInsuranceInformation?.controlledGroup) || "",
    isOnPeo: convertBoolIntoString(healthInsuranceInformation?.isOnPeo) || "",
    currentPeo: healthInsuranceInformation?.currentPeo || "",
    currentPeoOther: healthInsuranceInformation?.currentPeoOther || "",
    startingCoverageDate:
      ConvertToValidDate(healthInsuranceInformation?.startingCoverageDate) ||
      "",
  };
};
